/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {BasePermissionFormComponent as ɵc} from './basepermission-form/basepermission-form.component';
export {BasepermissionImportFormComponent as ɵd} from './basepermission-import-form/basepermission-import-form.component';
export {BasePermissionComponent as ɵb} from './basepermission.component';
export {declaration as ɵa} from './basepermission.module';
export {BasePermissionRoutes as ɵe} from './basepermission.routing';